import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-profile-logs',
  templateUrl: './profile-logs.component.html',
  styleUrls: ['./profile-logs.component.scss']
})


export class ProfileLogsComponent extends FeaturesBaseComponent implements OnInit {
  searchValue:any;
  gridApi: any;
  isLogSelected:boolean = false;
  gridColumnApi: any;
  selectedRows: any;
  showEditPromotion: boolean;
  isUserLogsActive:boolean = true;
  isSystemLogsActive:boolean = false;
  rowData: any;
  columnDefs:any;
  defaultColDef:any;
  date: any = new Date();

  constructor(private profileService : ProfileService) {
    super();
    this.profileService.getLogs().subscribe(res =>{
      if(res['httpcode']== 200){

        this.setGrid(res['data'])
      }
    })
  
  }
  setGrid(rowData) {
    this.rowData = rowData;
    this.columnDefs = [
      { field: 'logType', headerName: 'Log Type', width: 220,},
      { field: 'eventDttm', headerName: 'Date', width: 220, cellRenderer: (data) => {
          return moment(data.value).format('ll')
        }, sort: "desc" },
      { field: 'eventTime', headerName: 'Time', width: 220, cellRenderer: (data)=> {
          return moment(data.value).format('hh:mm:ss:a')
        }},
      { field: 'event', headerName: 'Event', width: 220,},
      { field: 'source', headerName: 'Source', width: 220,},
      { field: 'userName', headerName: 'Info changed for', width: 220,},
      { field: 'modifiedBy', headerName: 'Info Changed By', width: 240,},
      { field: 'device', headerName: 'Device', width: 220,},
      { field: 'userOS', headerName: 'User OS', width: 180,},
      { field: 'previousValue', headerName: 'Earlier', width: 180,},
      { field: 'currentValue', headerName: 'Now', width: 180,},
      { field: 'columnName', headerName: 'Field Changed', width: 200,},
      { field: 'ipAddress', headerName: 'IP', width: 180,},
      { field: 'location', headerName: 'Location', width: 180,},
      { field: 'userId', headerName: '', width: 0, hide: true},   
      
      
    ]
  
  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Profile-Logs.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'eventDttm') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'eventTime') {
        return moment(cellParams.value).format('hh:mm:ss:a')
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  } 
  ngOnInit(): void {
    super.ngOnInit()
  }

  onSelectUserLogs(){
    this.isUserLogsActive = true;
    this.isSystemLogsActive = !this.isUserLogsActive
  }
  onSelectSystemLogs(){
    this.isSystemLogsActive = true;
    this.isUserLogsActive = !this.isSystemLogsActive;
  }

  deleteLog(){

  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //console.log(this.gridApi);
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.isLogSelected = true;
      return
    }
    this.isLogSelected = false;

  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }


}
